import {Modal, message } from "antd";
const developingMessage = () => {
  message.warning({
    content: "正在开发中...",
    className: "custom-class",
    style: {
      marginTop: "20vh",
      fontSize: "20px",
      zIndex:'10000000'
    },
  });
};
const msgSuccess = (msg) => {
  message.success({
    content: msg,
    className: "custom-class",
    style: {
      marginTop: "20vh",
      fontSize: "20px",
      zIndex:'10000000'
    },
  });
};
const msgError = (msg) => {
  message.error({
    content: msg,
    className: "custom-class",
    style: {
      marginTop: "20vh",
      fontSize: "20px",
      zIndex:'10000000'
    },
  });
};
const getPhone = () => {
    Modal.info({
    title: '请联系',
    content: (
      <div>
        <p>18516687652</p>
      </div>
    ),
    onOk() {},
  });
};


export { developingMessage,msgSuccess,msgError,getPhone };
